import { map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import BaseDetailPageConfig from '../../../../models/base-detail-page.config';
import { BaseDetailPageComponent } from '../../../../components/pages/base-detail-page/base-detail-page.component';
import { AntivirusFileUploadLogService } from '../../../../services/api/antivirus-file-upload-log.service';

@Component({
  selector: 'app-antivirus-log-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './antivirus-log-detail-page.component.html',
  styleUrl: './antivirus-log-detail-page.component.scss'
})
export class AntivirusLogDetailPageComponent implements OnInit {
  baseDetailPageConfig!: BaseDetailPageConfig;

  constructor(
    private antivirusFileUploadLogService: AntivirusFileUploadLogService
  ) {}

  ngOnInit(): void {
    this.baseDetailPageConfig = {
      pageTitle: 'Antivirus File Upload Log',
      cardTitle: 'DETAILS',
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'antivirusLogId',
            label: 'ID',
            value: (item: any) => item.antivirusLogId
          },
          {
            attribute: 'user',
            label: 'USER',
            value: (item: any) => item.user ? `${item.user.firstName} ${item.user.lastName}` : ''
          },
          {
            attribute: 'type',
            label: 'Type',
            value: (item: any) => item.type
          },
          {
            attribute: 'section',
            label: 'Section',
            value: (item: any) => item.section
          },
          {
            attribute: 'category',
            label: 'Category',
            value: (item: any) => item.category
          },
          {
            attribute: 'referTable',
            label: 'Refer Table',
            value: (item: any) => item.referTable
          },
          {
            attribute: 'referId',
            label: 'Refer ID',
            value: (item: any) => item.referId
          },
          {
            attribute: 'fileName',
            label: 'File Name',
            value: (item: any) => item.fileName
          },
          {
            attribute: 'fileNameOriginal',
            label: 'File Name Original',
            value: (item: any) => item.fileNameOriginal
          },
          {
            attribute: 'mimeType',
            label: 'Mime Type',
            value: (item: any) => item.mimeType
          },
          {
            attribute: 'antivirusResult',
            label: 'Antivirus Result',
            value: (item: any) => {
              if (item.antivirusResult === 1 || item.antivirusResult === 2) {
                return 'Virus trovato';
              } else if (item.antivirusResult === 0) {
                return 'Pulito';
              } else {
                return 'Sconosciuto';
              }
            },
            icon: (item: any) => {
              if (item.antivirusResult === 1 || item.antivirusResult === 2) {
                return 'fa fa-exclamation-triangle text-danger';
              } else if (item.antivirusResult === 0) {
                return 'fa fa-shield text-success';
              } else {
                return 'fa fa-question text-secondary';
              }
            }
          },
          {
            attribute: 'status',
            label: 'Status',
            value: (item: any) => item.status
          },
          {
            attribute: 'createTime',
            label: 'Create Time',
            value: (item: any) => item.createTime
          }
        ]
      },
      apiDetailService: (id: number) => this.antivirusFileUploadLogService.detail(id),
      routeParamName: 'fileUploadId',
      responseModelName: 'antivirusLog'
    };
  }
}
